import { useContext } from 'react';
import { OpenApiContext, OpenApiContextData } from './context';

export function useOpenApi(): OpenApiContextData {
    const data = useContext<OpenApiContextData | undefined>(OpenApiContext);

    if (!data) {
        throw new Error(
            "OpenApi unavailable. Are you sure you're using this in a nested component of an OpenApiProvider?"
        );
    }

    return data;
}
